import { Controller } from "@hotwired/stimulus"
import debounce from "lodash/debounce"

export default class extends Controller {
  static targets = [
    "input",
    "hiddenInput",
    "results"
  ]

  static values = {
    searchType: String
  }

  connect() {
    this.search = debounce(this.search.bind(this), 300)
  }

  focus(event) {
    const query = this.inputTarget.value.trim()

    if (query.length >= 2) {
      this.performSearch(query)
    }
  }

  search() {
    if (this.inputTarget.disabled) return
    const query = this.inputTarget.value.trim()

    // Hide results if input is empty or too short
    if (!query || query.length < 2) {
      this.hiddenInputTarget.value = ''
      this.resultsTarget.classList.add('d-none')
      return
    }

    // Get supplier ID to exclude from search (not needed for now, but kept for consistency)
    const supplierId = ''

    // Fetch search results
    fetch(`/user_searches/search_suppliers?query=${encodeURIComponent(query)}&supplier_id=${encodeURIComponent(supplierId)}&search_type=${encodeURIComponent(this.searchTypeValue)}`)
      .then(response => response.text())
      .then(html => {
        this.resultsTarget.innerHTML = html
        this.resultsTarget.classList.remove('d-none')
      })
      .catch(error => {
        console.error('Error searching suppliers:', error)
        this.resultsTarget.innerHTML = '<div class="p-2 text-muted">Error en la búsqueda</div>'
        this.resultsTarget.classList.remove('d-none')
      })
  }

  performSearch(query) {
    this.search()
  }
}
